<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>
              {{ $t('Доверенности пользователя') }}
            </v-toolbar-title>
          </v-toolbar>
          <general-error v-if="!!generalError" />
          <v-card-text>
            <user-proxies-list
                ref="proxyList"
                :proxies="proxies"
                :total-count="totalCount"
                :edited="getCurrentUserProxyList"
                :loading="isLoading"
                can-create
                :create-method="createUserProxy"
                :proxy-type="proxyType"
                :document-group="documentGroup"
                enable-filters />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  import UserProxiesList from '@/components/reused/proxies/UserProxiesList.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { PROXY_TYPES, IDENTITY_DOCUMENT_GROUPS } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { CURRENT_USER_PROXIES } from '@/constants/store.js'

  export default {
    components: {
      UserProxiesList,
      GeneralError
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      ...mapState(CURRENT_USER_PROXIES.NAMESPACE, {
        proxiesInfo: state => (state[CURRENT_USER_PROXIES.STATE.PROXIES] || {})
      }),
      headers () {
        return [
          { text: this.$t('Доверенность'), sortable: false, value: 'file.fileName' },
          { text: this.$t('Дата начала действия'), sortable: false, value: 'dateBegin' },
          { text: this.$t('Дата завершения действия'), sortable: false, value: 'dateEnd' },
          { text: this.$t('ФИО доверенного лица'), sortable: false, value: 'contactPerson' },
          { text: this.$t('Статус'), sortable: false, value: 'status' },
          { text: this.$t('Действия'), sortable: false, value: 'file.fileId' }
        ]
      },
      proxies () {
        return this.proxiesInfo.items || []
      },
      totalCount () {
        return this.proxiesInfo.totalCount || 0
      },
      proxyType () {
        return PROXY_TYPES.USER_PROXY
      },
      documentGroup () {
        return IDENTITY_DOCUMENT_GROUPS.ORGANIZATION_AGENT_DOCUMENTS
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(CURRENT_USER_PROXIES.NAMESPACE, {
        getCurrentUserProxyListAction: CURRENT_USER_PROXIES.ACTIONS.GET_CURRENT_USER_PROXY_LIST,
        createUserProxyAction: CURRENT_USER_PROXIES.ACTIONS.CREATE_USER_PROXY,
        clearCurrentUserProxyListAction: CURRENT_USER_PROXIES.ACTIONS.CLEAR_CURRENT_USER_PROXY_LIST
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearCurrentUserProxyListAction()
          ])
      },
      getCurrentUserProxyList: async function (params) {
        try {
          this.isLoading = true
          await this.getCurrentUserProxyListAction(params)
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      createUserProxy: async function (proxy) {
        try {
          this.isLoading = true

          await this.createUserProxyAction({
            proxy
          })
          this.isLoading = false
          this.$refs.proxyList.getProxiesList()
        } catch (error) {
          this.isLoading = false
          throw error
        }
      }
    }
  }
</script>
